import React from "react";
import MultiRangeSlider from "multi-range-slider-react";
import DOMPurify from 'dompurify';
import {CategoryProp} from "./category";

export function ProductFilter (props:any) {    
    const {product_data, filters_in_use} = props;
    const {product_filter, requested_filters} = product_data;

    var price_data = null;
    var min_price = 0;
    var max_price = 0;
    var current_min = 0, current_max = 0;

    if(  product_data != null && product_filter != null ) {
        min_price = Math.floor(parseFloat(product_filter.filter_price.min_price));
        max_price = Math.ceil(parseFloat(product_filter.filter_price.max_price));
        
        current_min = Math.floor(parseFloat(requested_filters.min_price));
        current_max = Math.ceil(parseFloat(requested_filters.max_price));
    }

    var toggle_price_filter = ( max_price != 0 );

    if( min_price > 0 ) {
        min_price = 0;
    }
    
    if( max_price <= 0 ) {
        max_price = 100;
    }

    return (
        <div className="product--filter" style={{marginTop:"10px"}}>
            <div className="product--input-wrapper">
            <input
                type="search"
                name="filter_search"
                defaultValue=""
                placeholder="Search"
                onChange={event => {
                    const sanitizedValue = DOMPurify.sanitize(event.target.value);
                    props.onSearch(sanitizedValue);
                }}
            />
            </div>
            <div className="product--input-wrapper"><div className="spacer"></div></div>
            <div className="product--input-wrapper">
                <ul className="option--list">
                    {toggle_price_filter ?
                        <li className="option--row" style={{height:'80px'}}>
                            <div className="option--slider lms_filter_widget_content">
                                    <MultiRangeSlider 
                                        minValue={min_price} 
                                        maxValue={max_price} 
                                        min={min_price} 
                                        max={max_price} 
                                        step={1} 
                                        onChange={props.onRangeChange} 
                                    />
                                    <p className="price-range">Price: ${current_min} — ${current_max}</p>
                            </div>
                        </li>
                        : null
                    }
                    <li className="option--row-cat option-cat">
                        <div className='option-sub-cat'>
                            <div className="option--label" style={{marginRight:'10px', fontSize: '14px'}}>
                                <span>
                                    <input type="checkbox" onClick={props.onChecked} defaultChecked={!filters_in_use} data-cat={'all'}/> {"All"}
                                </span>
                            </div>
                        </div>
                    </li>
                    { product_data != null ?
                        <>
                            { product_filter != null ?
                                <>
                                <div className="cat--list">
                                    {
                                        Object.keys(product_filter.filter_cat).map((key:string, index:number) => {
                                            return <CategoryProp key={index.toString()} onChecked={props.onChecked} catKey={key} catData={product_filter.filter_cat} />
                                        })
                                    }
                                </div>
                                </>
                                : null
                            }
                        </>
                        : null
                    }
                </ul>
            </div>
        </div>
    )
    
}
